import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../../actions/ActionCreator";
import * as memberType from "../../actions/ActionType";
import { ENDPOINTS } from "../../URLs/AdminEndpoints.Vi";
import * as Api from "../../../appApi/AppApi"

const TAG = "getLeadsExcelReportSaga.js";

function* workerGetLeadsExcelReport(payload) {
  try {
    const response = yield call(
      Api.makeSecurePostRequestWithFileSaveOrWithEmailWithExtendedTimeout,
      ENDPOINTS.VI_ADMIN_GET_LEADS_EXCEL_REPORT,
      payload.data,
      payload.fileInfo.fileName,
      payload.fileInfo.fileExtension
    );
    yield put(memberAction.createActionOf(memberType.DOWNLOAD_LEADS_EXCEL_REPORT_SUCCESS, 1, response));
  } catch (error) {
    yield put(memberAction.createActionOf(memberType.DOWNLOAD_LEADS_EXCEL_REPORT_FAILED, 2, error));
  }
}

export const watchGetLeadsExcelReportSaga = takeLatest(
  memberType.DOWNLOAD_LEADS_EXCEL_REPORT_REQUESTED,
  workerGetLeadsExcelReport
);
